import React from 'react';
import PropTypes from 'prop-types';
import styles from './autoplayCarousel.styl';
import { VideoCard } from '../videoCard';
import ImageCard from '../imageCard';
import { gallerySlideShape, THEMES } from '../../shapes';
import { CARD_TYPES } from './constants';

export const AutoplayCarouselSlide = ({
  analyticsItemId = '',
  hashKey = '',
  colorTheme = THEMES.LIGHT,
  index = 0,
  itemCount = 0,
  collectionId = '',
  onAutoplayControl,
  ...slide
}) => {
  const actionButtons = slide?.actionButtons;
  const actionHashKeys = Array.isArray(actionButtons)
    ? actionButtons.map(btn => btn.analytics?.hashKey).filter(Boolean)
    : [];
  const slideContainerType = slide?.containerType?.toUpperCase();

  return (
    <div
      data-analytics-placement-id={analyticsItemId}
      data-is-carousel-content={slide?.isInCarousel}
      data-action-hashkeys={actionHashKeys}
      data-click-mod={hashKey}
      data-index={index}
      data-collection-id={collectionId}
      data-item-count={itemCount}
      data-analytics-has-landmark="true"
      data-qa="autoplay-carousel-item"
      className={styles.slide}
    >
      {slideContainerType === CARD_TYPES.VIDEO ? (
        <VideoCard
          {...slide}
          dataAnalyticsHasLandmark={false}
          colorTheme={colorTheme}
          controlOptions={slide?.controlOptions}
          preset="ambient"
          inAutoplayCarousel
          loop={false}
          onAutoplayControl={onAutoplayControl}
        />
      ) : (
        <ImageCard
          {...slide}
          dataAnalyticsHasLandmark={false}
          colorTheme={colorTheme}
        />
      )}
    </div>
  );
};

AutoplayCarouselSlide.propTypes = {
  ...gallerySlideShape,
  analyticsItemId: PropTypes.string,
  collectionId: PropTypes.string,
  hashKey: PropTypes.string,
  index: PropTypes.number,
  itemCount: PropTypes.number,
  onAutoplayControl: PropTypes.func,
};
